export default __webpack_public_path__ + "static/media/agustin.a0eb7bcc.jpg";